module.exports = __webpack_public_path__ + "img/HSSstandard.7f41fbda.jpg";